// ref: https://stackoverflow.com/a/38552302
import { dateWithOffset } from '$logic/client-device/time-offset.service'

export function parseJwt(token: string) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(char => `%${('00' + char.charCodeAt(0).toString(16)).slice(-2)}`)
      .join(''),
  )

  return JSON.parse(jsonPayload)
}

export function isExpiredJwt(token: string) {
  const json = parseJwt(token)
  return json?.exp && json.exp * 1000 < dateWithOffset()
}
